import { Link } from 'react-router-dom';

const Product = (props) => {
  const { section, product, selection } = props;
  const name = selection.length !== 0 && selection[0].name;
  const path = selection.length !== 0 && selection[0].path;
  const image = require(`../../assets/images/products/${product.img}`);
  return (
    <div className="product__container">
      <div className="product__background">
        <img src={image.default} alt={product.name} />
        <div className="product__intro-container">
          <div className="product__intro-wrapper column">
            <div className="product__intro-title">
              <h1>{product.name}</h1>
            </div>
            <div className="product__intro-price">
              <p>{product.price}</p>
            </div>
            <div className="product__intro-button">
              <Link
                to={{
                  pathname: `/detail/${product.id}`,
                  state: { section, name, path },
                }}
              >
                <button>자세히 보기</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Product;
